import React from 'react';
import TaxesFiltersBar from './TaxesFiltersBar';
import { useTaxesList } from '../../contextsProperty/ContextTaxes';
import { TaxListViewType } from '../../../types/taxes/taxesTypes';
import TaxList from './listView/TaxList';
import TaxesCalendar from './calendarView/TaxesCalendar';
import TaxPanel from './taxPanel/TaxPanel';
import { useSearchParams } from '../../../customHooks/useSearchParams';

const TaxesListView = () => {
    const { visibleView } = useTaxesList();
    const { getSearchParam, removeSearchParam } = useSearchParams({
        base64: true,
    });
    const openedPanelTaxId = getSearchParam('id');

    const handleClosePanel = () => {
        removeSearchParam('id');
    };

    return (
        <div className='taxes__page'>
            <TaxesFiltersBar />
            {visibleView === TaxListViewType.TABLE ? (
                <TaxList />
            ) : (
                <TaxesCalendar />
            )}
            <TaxPanel open={!!openedPanelTaxId} onClose={handleClosePanel} />
        </div>
    );
};

export default TaxesListView;
